import './header.css'
import person from './img/Frame 148.svg'
import without from './img/without not.svg'
import withnot from './img/with not.svg'
import { useMsal } from '@azure/msal-react'

export function Header(props) {
    const { accounts } = useMsal()
    let nameArr = accounts[0].name.split(' ')
    const name = `${nameArr[0]} ${nameArr[nameArr.length - 1]}`

    return (
        <div style={props.style} className={`header-component-content ${props.line ? 'line-header' : ''}`}>
            {props.children}
            <div className='profile-section'>
                {
                    props.notify ?
                        <img className='sino-profile-section' src={props.notify.length > 0 ? withnot : without} alt='sino' />
                        : <></>
                }

                <h1>{name}</h1>
                <div>
                    <img src={person} alt='person' />
                </div>
            </div>
        </div>
    )
}